import React from "react";
import { Banner } from "@xometry/xometry_loft";
import styled from "@emotion/styled"

declare type Kind = "outline" | "primary" | "warning" | "danger" | "gray" | "cta";

declare type BannerProps = {
  kind?: Kind;
  onButtonClick?: () => void;
  title?: string | React.ReactNode;
  buttonText?: string;
  children: React.ReactNode;
} & React.ComponentProps<"div">;

const BannerWrapper = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
`

export const PrivacyBannerBase = (props: BannerProps) => {
  return (
    <BannerWrapper id="privacy-banner">
      <Banner
        kind={props.kind}
        title={props.title}
        buttonText={props.buttonText}
        onButtonClick={props.onButtonClick}
      >
        {props.children}
      </Banner>
    </BannerWrapper>
  );
};
